import { render, staticRenderFns } from "./B2BWmsStatus.vue?vue&type=template&id=4d74dd28&scoped=true"
import script from "./B2BWmsStatus.vue?vue&type=script&lang=js"
export * from "./B2BWmsStatus.vue?vue&type=script&lang=js"
import style0 from "./B2BWmsStatus.vue?vue&type=style&index=0&id=4d74dd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d74dd28",
  null
  
)

export default component.exports